import { SYS_SPACE_RELATIVE_BP_XS_2_XS, SYS_SPACE_RELATIVE_BP_XS_XS, SYS_SPACE_RELATIVE_BP_XS_SM, SYS_SPACE_RELATIVE_BP_XS_MD, SYS_SPACE_RELATIVE_BP_XS_LG, SYS_SPACE_RELATIVE_BP_XS_XL, SYS_SPACE_RELATIVE_BP_XS_2_XL, SYS_SPACE_RELATIVE_BP_XS_3_XL, SYS_SPACE_RELATIVE_BP_XS_4_XL, SYS_SPACE_RELATIVE_BP_XS_5_XL, SYS_SPACE_RELATIVE_BP_XS_6_XL, SYS_SPACE_RELATIVE_BP_XS_7_XL, SYS_SPACE_RELATIVE_BP_XS_8_XL, SYS_SPACE_RELATIVE_BP_SM_2_XS, SYS_SPACE_RELATIVE_BP_SM_XS, SYS_SPACE_RELATIVE_BP_SM_SM, SYS_SPACE_RELATIVE_BP_SM_MD, SYS_SPACE_RELATIVE_BP_SM_LG, SYS_SPACE_RELATIVE_BP_SM_XL, SYS_SPACE_RELATIVE_BP_SM_2_XL, SYS_SPACE_RELATIVE_BP_SM_3_XL, SYS_SPACE_RELATIVE_BP_SM_4_XL, SYS_SPACE_RELATIVE_BP_SM_5_XL, SYS_SPACE_RELATIVE_BP_SM_6_XL, SYS_SPACE_RELATIVE_BP_SM_7_XL, SYS_SPACE_RELATIVE_BP_SM_8_XL, SYS_SPACE_RELATIVE_BP_MD_2_XS, SYS_SPACE_RELATIVE_BP_MD_XS, SYS_SPACE_RELATIVE_BP_MD_SM, SYS_SPACE_RELATIVE_BP_MD_MD, SYS_SPACE_RELATIVE_BP_MD_LG, SYS_SPACE_RELATIVE_BP_MD_XL, SYS_SPACE_RELATIVE_BP_MD_2_XL, SYS_SPACE_RELATIVE_BP_MD_3_XL, SYS_SPACE_RELATIVE_BP_MD_4_XL, SYS_SPACE_RELATIVE_BP_MD_5_XL, SYS_SPACE_RELATIVE_BP_MD_6_XL, SYS_SPACE_RELATIVE_BP_MD_7_XL, SYS_SPACE_RELATIVE_BP_MD_8_XL, SYS_SPACE_RELATIVE_BP_LG_2_XS, SYS_SPACE_RELATIVE_BP_LG_XS, SYS_SPACE_RELATIVE_BP_LG_SM, SYS_SPACE_RELATIVE_BP_LG_MD, SYS_SPACE_RELATIVE_BP_LG_LG, SYS_SPACE_RELATIVE_BP_LG_XL, SYS_SPACE_RELATIVE_BP_LG_2_XL, SYS_SPACE_RELATIVE_BP_LG_3_XL, SYS_SPACE_RELATIVE_BP_LG_4_XL, SYS_SPACE_RELATIVE_BP_LG_5_XL, SYS_SPACE_RELATIVE_BP_LG_6_XL, SYS_SPACE_RELATIVE_BP_LG_7_XL, SYS_SPACE_RELATIVE_BP_LG_8_XL, SYS_SPACE_RELATIVE_BP_XL_2_XS, SYS_SPACE_RELATIVE_BP_XL_XS, SYS_SPACE_RELATIVE_BP_XL_SM, SYS_SPACE_RELATIVE_BP_XL_MD, SYS_SPACE_RELATIVE_BP_XL_LG, SYS_SPACE_RELATIVE_BP_XL_XL, SYS_SPACE_RELATIVE_BP_XL_2_XL, SYS_SPACE_RELATIVE_BP_XL_3_XL, SYS_SPACE_RELATIVE_BP_XL_4_XL, SYS_SPACE_RELATIVE_BP_XL_5_XL, SYS_SPACE_RELATIVE_BP_XL_6_XL, SYS_SPACE_RELATIVE_BP_XL_7_XL, SYS_SPACE_RELATIVE_BP_XL_8_XL, SYS_SPACE_RELATIVE_BP_XXL_2_XS, SYS_SPACE_RELATIVE_BP_XXL_XS, SYS_SPACE_RELATIVE_BP_XXL_SM, SYS_SPACE_RELATIVE_BP_XXL_MD, SYS_SPACE_RELATIVE_BP_XXL_LG, SYS_SPACE_RELATIVE_BP_XXL_XL, SYS_SPACE_RELATIVE_BP_XXL_2_XL, SYS_SPACE_RELATIVE_BP_XXL_3_XL, SYS_SPACE_RELATIVE_BP_XXL_4_XL, SYS_SPACE_RELATIVE_BP_XXL_5_XL, SYS_SPACE_RELATIVE_BP_XXL_6_XL, SYS_SPACE_RELATIVE_BP_XXL_7_XL, SYS_SPACE_RELATIVE_BP_XXL_8_XL } from '../../../../../tokens/spacing.generated.js';
export const systemSpaceRelative = {
    xs: [
        { '2xs': SYS_SPACE_RELATIVE_BP_XS_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_XS_XS },
        { sm: SYS_SPACE_RELATIVE_BP_XS_SM },
        { md: SYS_SPACE_RELATIVE_BP_XS_MD },
        { lg: SYS_SPACE_RELATIVE_BP_XS_LG },
        { xl: SYS_SPACE_RELATIVE_BP_XS_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_XS_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_XS_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_XS_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_XS_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_XS_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_XS_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_XS_8_XL }
    ],
    sm: [
        { '2xs': SYS_SPACE_RELATIVE_BP_SM_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_SM_XS },
        { sm: SYS_SPACE_RELATIVE_BP_SM_SM },
        { md: SYS_SPACE_RELATIVE_BP_SM_MD },
        { lg: SYS_SPACE_RELATIVE_BP_SM_LG },
        { xl: SYS_SPACE_RELATIVE_BP_SM_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_SM_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_SM_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_SM_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_SM_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_SM_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_SM_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_SM_8_XL }
    ],
    md: [
        { '2xs': SYS_SPACE_RELATIVE_BP_MD_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_MD_XS },
        { sm: SYS_SPACE_RELATIVE_BP_MD_SM },
        { md: SYS_SPACE_RELATIVE_BP_MD_MD },
        { lg: SYS_SPACE_RELATIVE_BP_MD_LG },
        { xl: SYS_SPACE_RELATIVE_BP_MD_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_MD_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_MD_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_MD_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_MD_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_MD_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_MD_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_MD_8_XL }
    ],
    lg: [
        { '2xs': SYS_SPACE_RELATIVE_BP_LG_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_LG_XS },
        { sm: SYS_SPACE_RELATIVE_BP_LG_SM },
        { md: SYS_SPACE_RELATIVE_BP_LG_MD },
        { lg: SYS_SPACE_RELATIVE_BP_LG_LG },
        { xl: SYS_SPACE_RELATIVE_BP_LG_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_LG_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_LG_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_LG_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_LG_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_LG_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_LG_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_LG_8_XL }
    ],
    xl: [
        { '2xs': SYS_SPACE_RELATIVE_BP_XL_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_XL_XS },
        { sm: SYS_SPACE_RELATIVE_BP_XL_SM },
        { md: SYS_SPACE_RELATIVE_BP_XL_MD },
        { lg: SYS_SPACE_RELATIVE_BP_XL_LG },
        { xl: SYS_SPACE_RELATIVE_BP_XL_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_XL_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_XL_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_XL_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_XL_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_XL_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_XL_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_XL_8_XL }
    ],
    xxl: [
        { '2xs': SYS_SPACE_RELATIVE_BP_XXL_2_XS },
        { xs: SYS_SPACE_RELATIVE_BP_XXL_XS },
        { sm: SYS_SPACE_RELATIVE_BP_XXL_SM },
        { md: SYS_SPACE_RELATIVE_BP_XXL_MD },
        { lg: SYS_SPACE_RELATIVE_BP_XXL_LG },
        { xl: SYS_SPACE_RELATIVE_BP_XXL_XL },
        { '2xl': SYS_SPACE_RELATIVE_BP_XXL_2_XL },
        { '3xl': SYS_SPACE_RELATIVE_BP_XXL_3_XL },
        { '4xl': SYS_SPACE_RELATIVE_BP_XXL_4_XL },
        { '5xl': SYS_SPACE_RELATIVE_BP_XXL_5_XL },
        { '6xl': SYS_SPACE_RELATIVE_BP_XXL_6_XL },
        { '7xl': SYS_SPACE_RELATIVE_BP_XXL_7_XL },
        { '8xl': SYS_SPACE_RELATIVE_BP_XXL_8_XL }
    ]
};
//# sourceMappingURL=space.js.map